import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import { Message } from 'element-ui';

const routes = [
    {
        path: '/',
        redirect: "/home"
    },
    {
        path: "/login",
        component: resolve => require(['@/views/login/login.vue'], resolve),
    },
    {
        path: "/register",
        component: resolve => require(['@/views/login/register.vue'], resolve),
    },
    {
        path: "/wangji",
        component: resolve => require(['@/views/login/wangji.vue'], resolve),
    },
    {
        path: '/i18nExample',
        name: 'i18nExample',
        component: resolve => require(['@/views/i18nExample.vue'], resolve),
    },
    {
        path: '/home',
        component: resolve => require(['@/views/home/home.vue'], resolve),
        children: [
            {
                path: "",
                redirect: "index"
            },
            {
                path: "liaotian",
                component: resolve => require(['@/views/home/_children/im/liaotian.vue'], resolve),
            },
            {
                path: "select_shenfen",
                component: resolve => require(['@/views/login/select_shenfen.vue'], resolve),
            },
            {
                path: 'index',
                component: resolve => require(['@/views/home/_children/index.vue'], resolve),
            },
            {
                path: 'all_course',
                component: resolve => require(['@/views/home/_children/course/all_course.vue'], resolve),
            },
            {
                path: 'course_detail',
                component: resolve => require(['@/views/home/_children/course/course_detail.vue'], resolve),
            },
            {
                path: 'course_play',
                component: resolve => require(['@/views/home/_children/course/course_play.vue'], resolve),
            },
            {
                path: 'course_lianxi',
                component: resolve => require(['@/views/home/_children/dati/course_lianxi.vue'], resolve),
            },
            {
                path: 'course_mokao',
                component: resolve => require(['@/views/home/_children/dati/course_mokao.vue'], resolve),
            },
            {
                path: 'kaoshi',
                component: resolve => require(['@/views/home/_children/kaoshi/kaoshi.vue'], resolve),
            },
            {
                path: 'kaoshi_detail',
                component: resolve => require(['@/views/home/_children/kaoshi/kaoshi_detail/kaoshi_detail.vue'], resolve),
            },
            {
                path: 'jingsai',
                component: resolve => require(['@/views/home/_children/jingsai/jingsai.vue'], resolve),
            },
            {
                path: 'jingsai_detail',
                component: resolve => require(['@/views/home/_children/jingsai/jingsai_detail/jingsai_detail.vue'], resolve),
            },
            {
                path: 'jingsai_paihang',
                component: resolve => require(['@/views/home/_children/jingsai/jingsai_paihang/jingsai_paihang.vue'], resolve),
            },
            {
                path: 'paihangbang_detail',
                component: resolve => require(['@/views/home/_children/jingsai/paihangbang_detail/paihangbang_detail.vue'], resolve),
            },
            {
                path: 'rencai',
                component: resolve => require(['@/views/home/_children/rencai/rencaiku.vue'], resolve),
            },
            {
                path: 'rencai_detail',
                component: resolve => require(['@/views/home/_children/rencai/rencai_detail.vue'], resolve),
            },
            {
                path: 'rencai_zhengshu',
                desc: "人才证书",
                component: resolve => require(['@/views/home/_children/rencai/rencai_zhengshu.vue'], resolve),
            },
            {
                path: 'rencai_jingsailist',
                desc: "人才竞赛记录列表",
                component: resolve => require(['@/views/home/_children/rencai/rencai_jingsailist.vue'], resolve),
            },
            {
                path: 'qiye_detail',
                component: resolve => require(['@/views/home/_children/rencai/qiye_detail.vue'], resolve),
            },
            {
                path: 'ai_mianshiguan',
                component: resolve => require(['@/views/home/_children/ai/ai_mianshiguan.vue'], resolve),
            },
            {
                path: 'ai_chuangke',
                component: resolve => require(['@/views/home/_children/ai/ai_chuangke.vue'], resolve),
            },
            {
                path: 'error_topic_detail',
                component: resolve => require(['@/views/home/_children/my/_children/my_error/error_topic_detail.vue'], resolve),
            },
            {
                path: 'kaoshi_and_jingsai_dati',
                component: resolve => require(['@/views/home/_children/my/_children/myBaoming/kaoshi_and_jingsai_dati/kaoshi_and_jingsai_dati.vue'], resolve),
            },
            {
                path: 'my_monikaoshi_error_topic_detail',
                component: resolve => require(['@/views/home/_children/my/_children/my_monikaoshi/my_monikaoshi_error_topic_detail.vue'], resolve),
            },
            {
                path: 'my',
                component: resolve => require(['@/views/home/_children/my/my.vue'], resolve),
                children: [
                    {
                        path: "",
                        redirect: "my_kaoshi"
                    },
                    {
                        path: 'myBaoming',
                        component: resolve => require(['@/views/home/_children/my/_children/myBaoming/myBaoming.vue'], resolve),
                    },
                    {
                        path: 'my_kaoshi',
                        component: resolve => require(['@/views/home/_children/my/_children/my_kaoshi/my_kaoshi.vue'], resolve),
                    },
                    {
                        path: 'my_jingsai',
                        component: resolve => require(['@/views/home/_children/my/_children/my_jingsai/my_jingsai.vue'], resolve),
                    },
                    {
                        path: 'my_monikaoshi',
                        component: resolve => require(['@/views/home/_children/my/_children/my_monikaoshi/my_monikaoshi.vue'], resolve),
                    },
                    {
                        path: 'my_zhengshu',
                        component: resolve => require(['@/views/home/_children/my/_children/my_zhengshu/my_zhengshu.vue'], resolve),
                    },
                    {
                        path: 'my_collect',
                        component: resolve => require(['@/views/home/_children/my/_children/my_collect/my_collect.vue'], resolve),
                    },
                    {
                        path: 'my_buy',
                        component: resolve => require(['@/views/home/_children/my/_children/my_buy/my_buy.vue'], resolve),
                    },
                    {
                        path: 'my_course',
                        component: resolve => require(['@/views/home/_children/my/_children/my_course/my_course.vue'], resolve),
                    },
                    {
                        path: 'my_error',
                        component: resolve => require(['@/views/home/_children/my/_children/my_error/my_error.vue'], resolve),
                    },
                ],
            },
            {
                path: 'user',
                component: resolve => require(['@/views/home/_children/user/user.vue'], resolve),
                children: [
                    {
                        path: "",
                        redirect: "person_info"
                    },
                    {
                        path: 'qiyexiaohaojilu',
                        component: resolve => require(['@/views/home/_children/user/_children/qiyexiaohaojilu/qiyexiaohaojilu.vue'], resolve),
                    },
                    {
                        path: 'qiyegoumai',
                        component: resolve => require(['@/views/home/_children/user/_children/qiyegoumai/qiyegoumai.vue'], resolve),
                    },
                    {
                        path: 'person_info',
                        component: resolve => require(['@/views/home/_children/user/_children/person_info/person_info.vue'], resolve),
                    },
                    {
                        path: 'user_authen',
                        component: resolve => require(['@/views/home/_children/user/_children/user_authen/user_authen.vue'], resolve),
                    },
                    {
                        path: 'qiye_authen',
                        component: resolve => require(['@/views/home/_children/user/_children/qiye_authen/qiye_authen.vue'], resolve),
                    },
                    {
                        path: 'address_manage',
                        component: resolve => require(['@/views/home/_children/user/_children/addres_manage/addres_manage.vue'], resolve),
                    },
                    {
                        path: 'zaixiaoxuesheng_authen',
                        component: resolve => require(['@/views/home/_children/user/_children/zaixiaoxuesheng_authen/zaixiaoxuesheng_authen.vue'], resolve),
                    },
                    {
                        path: 'zhiweiguanli',
                        component: resolve => require(['@/views/home/_children/user/_children/zhiweiguanli/zhiweiguanli.vue'], resolve),
                    },
                ]
            },
        ]
    },
    {
        path: '/other',
        component: resolve => require(['@/views/other/other.vue'], resolve),
        children: [
            {
                path: "",
                redirect: "other1"
            },
            {
                path: 'other1',
                component: resolve => require(['@/views/other/_children/other1.vue'], resolve),
            }
        ]
    },
]

const router = new VueRouter({
    mode: process.env.NODE_ENV === 'production' ? 'history' : 'hash',
    base: process.env.BASE_URL,
    routes
})

// 白名单
const whiteRoute = [
    '/login',
    '/login/forgotpassword',
    "/wangji",
    "/register",
    "/home/index",
    "/home/all_course",
    "/home/course_detail",
]

// 路由拦截
router.beforeEach((to, form, next) => {
    var tk = localStorage.getItem('token');
    console.debug('to', to.path)
    if (!tk && !whiteRoute.some(t => t == to.path)) next({ path: '/login' })
    // else next()

    var tk = localStorage.getItem('token');
    try {
        const ui = JSON.parse(localStorage.getItem('user_info'))
        if (tk && ui.user_type == 0 && to.path != "/home/select_shenfen") {
            next({ path: '/home/select_shenfen' })
            Message({
                message: "请选择身份",
                type: "error",
                offset: window.innerHeight / 2 - 30,
            })
        }
        else {
            next()
        }
        return;
    } catch (error) { }

    next();
})

export default router
